import React, { useState, useEffect  } from 'react'
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom'
import {
  Container,
  Row,
  Col,
  Input,
  Button,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from 'reactstrap';
import * as MyAPI from '../../../utils/MyAPI'
import Header from '../parts/Header'
import Footer from '../parts/Footer'
import ApiSubHeader from '../parts/ApiSubHeader'
import Alert from 'react-s-alert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ApiTokenManageListItem from './ApiTokenManageListItem'
import MontoringWordItem from './MontoringWordItem'
import { Loader } from 'react-overlay-loader';
import 'react-overlay-loader/styles.css';
import GenerateMonitoringWordModal from './GenerateMonitoringWordModal'

// ApiMonitoringWordManager
const ApiMonitoringWordManager = (props) => {

  let navigate = useNavigate();
  let login_token = useSelector(state => {
    if (state.user && state.user.login_token) {
      return state.user.login_token
    } else {
      return ''
    }
  });
  let subscription_status = useSelector(state => {
    if (state.user && state.user.subscription_status) {
      return state.user.subscription_status
    } else {
      return 'unknown'
    }
  });

  let [loading, setLoading] = useState(false)
  let [kanjiInput, setKanjiInput] = useState("")
  let [kanaInput, setKanaInput] = useState("")
  // let [typeInput, setTypeInput] = useState("")
  // let [deepSpeechTokens, setDeepSpeechTokens] = useState([]);
  let [apiIdSelected, setApiIdSelected] = useState("")
  let [vocabList, setVocabList] = useState([])
  let [skip, setSkip] = useState(0)
  let [totalVocabCount, setTotalVocabCount] = useState(0)
  let [searchText, setSearchText] = useState("")
  // let [editMode, setEditMode] = useState("default")

  // let [addDictModalOpen, setAddDictModalOpen] = useState(false)
  let [addMonitoringWordModalOpen, setAddMonitoringWordModalOpen] = useState(false)
  let [monitoringWordList, setMonitoringWordList] = useState([]);

  // componentDidMount
  useEffect(() => {

    _firstScript()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let _firstScript = () => {

    if (!login_token) {
      // redirect
      navigate("/dashboard")
      return
    }

    if (subscription_status !== "active") {
      navigate("/api_manager_top")
      return
    }

    _getMonitoringWordList()

  }

  // get monitoring keyword list
  let _getMonitoringWordList = async () => {


    setLoading(true)

    try {
      // logout on server
      let _results = await MyAPI.getMontoringWordList({
        login_token: login_token,
      })

      if (_results.status === "error") {
        throw Error(_results.message)
      }

      console.log("getMontoringWordList: ", _results)

      // setDeepSpeechTokens(_list1)
      if (_results.list1) {
        setMonitoringWordList(_results.list1)
      }


    } catch (err) {
      console.log("err: ", err)
      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    }

    setLoading(false)
  }

  // keyword list from one list
  let _getVocabList = async ({
    list_id,
    skip2,
  }) => {

    setLoading(true)

    try {

      if (!list_id) {
        throw Error("no list_id is selected")
      }

      // get keywords
      let _results = await MyAPI.getMonitoringKeywordsFromList({
        login_token: login_token,
        list_id: list_id,
        skip: skip2,
        search_text: searchText,
      })

      if (_results.status === "error") {
        throw Error(_results.message)
      }

      if ( _results.list1 ) {
        setVocabList(_results.list1)
      } else {
        setVocabList([])
      }

      if (_results.count1) {
        setTotalVocabCount(_results.count1)
      } else {
        setTotalVocabCount(0)
      }

    } catch (err) {
      console.log("err: ", err)
    }

    setLoading(false)
  }

  // handle kanjiInput change
  let _kanjiInputChanged = (e) => {
    setKanjiInput(e.target.value)
  }

  // handle kanaInput change
  let _kanaInputChanged = (e) => {
    setKanaInput(e.target.value)
  }

  // // handle typeInput change
  // let _typeInputChanged = (e) => {
  //   setTypeInput(e.target.value)
  // }

  // add a word into dictionary
  let _addVocab2Dict = async () => {

    setLoading(true)

    try {

      if (!apiIdSelected) {
        throw Error("no api is selected")
      }

      if (!kanjiInput) {
        throw Error("kanji is not detected")
      }

      if (!kanaInput) {
        throw Error("kana is not detected")
      }

      // add
      let _results = await MyAPI.addOneWord2MontoringWords({
        login_token: login_token,
        kanji: kanjiInput,
        kana: kanaInput,
        // type: typeInput,
        list_id: apiIdSelected,
      })

      if (_results.status === "error") {
        throw Error(_results.message)
      }

      Alert.success("追加しました", {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

      // get vocab list again
      _getVocabList({
        ai_api_id: apiIdSelected,
        skip2: skip
      })

      // setTypeInput("")
      setKanaInput("")
      setKanjiInput("")

    } catch (err) {
      console.log("err: ", err)
      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    }

    setLoading(false)
  }

  // api selected changed
  let _apiIdSelectedChanged = (e) => {

    setApiIdSelected(e.target.value)

    _getVocabList({
      // ai_api_id: e.target.value,
      list_id: e.target.value,
      skip2: skip,
    })
  }

  // delete vocab
  let _deleteVocab = async (vocab_item) => {

    setLoading(true)

    try {

      if (!vocab_item) {
        throw Error("no api is selected")
      }

      // delete
      let _results = await MyAPI.deleteOneWordFromMonitoringWords({
        login_token: login_token,
        word_id: vocab_item._id,
        // ai_api_id: apiIdSelected,
      })

      if (_results.status === "error") {
        throw Error(_results.message)
      }

      Alert.success("削除しました", {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

      // get vocab list again
      _getVocabList({
        ai_api_id: apiIdSelected,
        skip2: skip,
      })

      // setTypeInput("")
      setKanaInput("")
      setKanjiInput("")

    } catch (err) {
      console.log("err: ", err)
      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    }

    setLoading(false)
  }


  // update updatedAt
  let _updateUpdatedAt = async (item) => {

    setLoading(true)

    try {

      // get evaluation masters
      const results_1 = await MyAPI.updateVocabUpdatedAt({
        login_token: login_token,
        vocab_id: item._id,
      })
      if (results_1.status !== "success") {
        throw Error(results_1.message)
      }

      // get vocabs
      _getVocabList({
        list_id: apiIdSelected,
        skip2: 0,
      })

    } catch (err) {
      console.log("err: ", err )

      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

    }
    setLoading(false)
  }


  // toggle 同音異義語
  let _toggleDoOnIgigoExists = async (item) => {

    setLoading(true)

    try {

      // get evaluation masters
      const results_1 = await MyAPI.toggleDoOnIgigoExists({
        login_token: login_token,
        vocab_id: item._id,
        ai_api_id: apiIdSelected,
      })
      if (results_1.status !== "success") {
        throw Error(results_1.message)
      }

      // get vocabs
      _getVocabList({
        list_id: apiIdSelected,
        skip2: skip,
      })

    } catch (err) {
      console.log("err: ", err )

      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

    }
    setLoading(false)
  }

  // _searchTextChanged
  let _searchTextChanged = (e) => {
    setSearchText(e.target.value)
  }

  // go next 100
  let _goNext = () => {

    let _skip = skip
    _skip = _skip + 100

    if (_skip > totalVocabCount) {
      _skip = totalVocabCount
    }

    setSkip(_skip)

    // get vocabs
    _getVocabList({
      list_id: apiIdSelected,
      skip2: _skip,
    })
  }

  // go back
  let _goBack = () => {
    let _skip = skip
    _skip = _skip - 100
    if (_skip < 0) {
      _skip = 0
    }
    setSkip(_skip)

    // get vocabs
    _getVocabList({
      list_id: apiIdSelected,
      skip2: _skip,
    })
  }

  // // toggle edit mode
  // let _toggleEditMode = () => {
  //   if ( editMode === "default" ) {
  //     setEditMode("interactive")
  //   } else {
  //     setEditMode("default")
  //   }
  // }

  // show alert
  let _showAlert = (message, type) => {

    if (type === "info") {
      Alert.info(message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    } else if (type === "success") {
      Alert.success(message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    } else if (type === "error") {
      Alert.error(message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    }
  }

  // set loader
  let _setLoading = (arg) => {
    setLoading(arg)
  }

  // get vocabs again
  let _getVocabListAgain = (list_id) => {

    // get vocabs
    _getVocabList({
      list_id: list_id,
      skip2: 0,
    })
  }


  // toggle 重要後
  let _toggleImportantWord = async (item, rank) => {

    setLoading(true)

    try {

      // console.log("_toggleImportantWord.rank: ", rank)

      // get evaluation masters
      const results_1 = await MyAPI.toggleImportantWord({
        login_token: login_token,
        vocab_id: item._id,
        ai_api_id: apiIdSelected,
        rank: rank,
      })
      if (results_1.status !== "success") {
        throw Error(results_1.message)
      }

      // get vocabs
      _getVocabList({
        list_id: apiIdSelected,
        skip2: skip,
      })


    } catch (err) {
      console.log("err: ", err )

      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

    }
    setLoading(false)
  }

  // show generate new dictionary key modal
  let _showGenerateNewMonitoringWordModal = () => {
    // setAddDictModalOpen(true)
    setAddMonitoringWordModalOpen(true)
  }

  let _closeAddDictModal = () => {
    // setAddDictModalOpen(false)
    setAddMonitoringWordModalOpen(false)

    _getMonitoringWordList()
    // _getSharableDictionaryList()
  }

  // // _getSharableDictionaryList
  // let _getSharableDictionaryList = async () => {
  //
  //   setLoading(true)
  //
  //   try {
  //     // logout on server
  //     let _results = await MyAPI.getSharableDictionaryList({
  //       login_token: login_token,
  //       include_public: false,
  //     })
  //
  //     if (_results.status === "error") {
  //       throw Error(_results.message)
  //     }
  //
  //
  //     // name to display
  //     let _list1 = _results.list1
  //     for ( let i=0; i<_list1.length; i++ ) {
  //
  //       let _item = _list1[i]
  //       _list1[i]._id = "dict_"+_item._id
  //       _list1[i].disp_name = _item.dictionary_name
  //     }
  //
  //     setDeepSpeechTokens(_list1)
  //
  //   } catch (err) {
  //     console.log("err: ", err)
  //     Alert.error(err.message, {
  //       position: 'top-right',
  //       effect: 'slide',
  //       timeout: 5000
  //     });
  //   }
  //   setLoading(false)
  // }

  return (
    <div>

      <Header />

      <ApiSubHeader />

      {/* main */}
      <Container style={{
        marginTop: 40,
        minHeight: 300,
      }}>

        {/* api keys */}
        <Row style={{
          // backgroundColor: '#cccccc',
          marginTop: 10,
          marginBottom: 5,
        }}>

          <Col md="6" xs="12" style={{
            textAlign: 'left',
          }}>

            <span style={{
              marginRight: 6,
            }}>
              選択してください
            </span>

            <span style={{
              marginRight: 6,
            }}>
              新しいキーワードリストを作成→
            </span>

            <FontAwesomeIcon
              onClick={_showGenerateNewMonitoringWordModal}
              icon="circle-plus"
              style={{
                cursor: 'pointer',
                marginLeft: 6,
            }}/>

          </Col>

          <Col md="6" xs="12" />
        </Row>

        <Row style={{
          // backgroundColor: '#cccccc',
          marginTop: 5,
          marginBottom: 40,
        }}>

          <Col md="6" xs="12" style={{
            textAlign: 'left',
          }}>
            <Input onChange={_apiIdSelectedChanged}
              type="select"
              name="apiIdSelected"
              value={apiIdSelected}>

              <option
                key={"dummy_api_key_id"}
                value={""}>
                  選択してください
              </option>

              {monitoringWordList.map((item) => (
                <option
                  key={item._id}
                  value={item._id}>
                    {item.list_name}
                </option>
              ))}
            </Input>
          </Col>

          <Col md="6" xs="12" style={{
            textAlign: 'right',
            fontSize: 18,
          }}>

          </Col>

        </Row>


        {/* vocab headers */}
        {/* default mode */}
        {apiIdSelected && (
          <div>

            {/* controller */}
            <Row style={{
              backgroundColor: '#ffffff',
              marginTop: 10,
              marginBottom: 10,
            }}>
              <Col md="6" xs="12">

                {/* search bar */}
                {/*<InputGroup>

                  <Input
                    name='search_text'
                    onChange={_searchTextChanged}
                    value={searchText}
                    placeholder='かな' />

                  <InputGroupAddon addonType="append">
                    <InputGroupText>
                      <FontAwesomeIcon
                        onClick={() => _getVocabList({ list_id: apiIdSelected, skip2: skip })}
                        icon="search"
                        style={{
                          cursor: 'pointer',
                      }}/>
                    </InputGroupText>
                  </InputGroupAddon>

                </InputGroup>*/}

              </Col>

              <Col md="6" xs="12" style={{
                textAlign: 'right',
              }}>

                {skip !== 0 ? (
                  <FontAwesomeIcon
                    onClick={_goBack}
                    icon="arrow-left"
                    style={{
                      cursor: 'pointer',
                      marginRight: 10,
                  }}/>
                ) : (
                  <FontAwesomeIcon
                    icon="arrow-left"
                    style={{
                      color: '#cccccc',
                      marginRight: 10,
                  }}/>
                )}

                {skip+100 > totalVocabCount ? (
                  <FontAwesomeIcon
                    icon="arrow-right"
                    style={{
                      marginLeft: 10,
                      color: '#cccccc',
                  }}/>
                ) : (
                  <FontAwesomeIcon
                    onClick={_goNext}
                    icon="arrow-right"
                    style={{
                      marginLeft: 10,
                      cursor: 'pointer',
                  }}/>
                )}

              </Col>
            </Row>


            <Row style={{
              backgroundColor: '#555555',
              color: '#ffffff',
              marginTop: 10,
              marginBottom: 10,
              marginLeft: 0,
              marginRight: 0,
            }}>

              <Col md="3" xs="12" style={{
                textAlign: 'left',
              }}>
                <span>
                  漢字
                </span>
              </Col>
              <Col md="3" xs="12" style={{
                textAlign: 'left',
              }}>
                <span>
                  かな
                </span>
              </Col>
              <Col md="3" xs="12" style={{
                textAlign: 'left',
              }}>
                {/*<span>
                  タイプ
                </span>*/}
              </Col>
              <Col md="3" xs="12" style={{
                textAlign: 'left',
              }}>

              </Col>
            </Row>

            {/* vocab add */}
            <Row style={{
              // backgroundColor: '#cccccc',
              marginTop: 10,
              marginBottom: 10,
            }}>

              <Col md="3" xs="12" style={{
                textAlign: 'left',
              }}>

                <Input
                  type="text"
                  style={{
                    width: '100%',
                  }}
                  name='kanjiInput'
                  onChange={_kanjiInputChanged}
                  value={kanjiInput} />

              </Col>
              <Col md="3" xs="12" style={{
                textAlign: 'left',
              }}>
                <Input
                  type="text"
                  style={{
                    width: '100%',
                  }}
                  name='kanaInput'
                  onChange={_kanaInputChanged}
                  value={kanaInput} />
              </Col>
              <Col md="3" xs="12" style={{
                textAlign: 'left',
              }}>
                {/*<Input onChange={_typeInputChanged}
                  type="select"
                  name="typeInput"
                  value={typeInput}>
                  <option value=""> - </option>
                  <option value="人名">人名</option>
                  <option value="組織">組織</option>
                </Input>*/}
              </Col>
              <Col md="3" xs="12" style={{
                textAlign: 'left',
              }}>
                <Button onClick={_addVocab2Dict} color="primary">
                  追加
                </Button>
              </Col>

            </Row>


            {/* vocab list */}
            {vocabList.map((item, idx) => (
              <MontoringWordItem
                idx={idx}
                key={item._id}
                item={item}
                updateUpdatedAt={_updateUpdatedAt}
                toggleImportantWord={_toggleImportantWord}
                toggleDoOnIgigoExists={_toggleDoOnIgigoExists}
                deleteVocab={_deleteVocab}/>
            ))}

          </div>
        )}

      </Container>

      <br/>

      {/* footer */}
      <Footer />

      {/* add new dictionary modal */}
      <GenerateMonitoringWordModal
        login_token={login_token}
        showAlert={_showAlert}
        setLoading={setLoading}
        closeModal={_closeAddDictModal}
        isOpen={addMonitoringWordModalOpen} />

      {/* loading */}
      <Loader fullPage={true} loading={loading} />

    </div>
  )
}

export default ApiMonitoringWordManager
